(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nt-cart-drawer"] && !Shopify.designMode) return;
  try {
    const sacola = document.getElementById('nt-sacola');
  if (sacola) {
    // Voltou de /cart/add com ?sacola=1: reabre a gaveta onde ela estava.
    if (new URLSearchParams(location.search).get('sacola') === '1') {
      sacola.showModal();
      const limpo = new URL(location.href);
      limpo.searchParams.delete('sacola');
      history.replaceState(null, '', limpo);
    }
    // Remover um item. Recarrega com ?sacola=1 em vez de redesenhar a gaveta:
    // o total, os adicionais sugeridos e a trava de "so adicionais" sao todos
    // Liquid, e refaze-los no navegador seria manter uma segunda versao da
    // mesma conta. A reabertura ja existia para a volta do /cart/add.
    document.addEventListener('click', async (evento) => {
      const x = evento.target.closest('[data-nt-remover]');
      if (!x) return;
      x.disabled = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(x.dataset.ntRemover), quantity: 0 }),
        });
        const volta = new URL(location.href);
        volta.searchParams.set('sacola', '1');
        location.href = volta.toString();
      } catch (e) {
        x.disabled = false;
      }
    });

    document.addEventListener('click', (evento) => {
      const gatilho = evento.target.closest('[data-nt-sacola-abrir]');
      if (gatilho) {
        evento.preventDefault();
        sacola.showModal();
        return;
      }
      if (evento.target.closest('[data-nt-sacola-fechar]')) {
        sacola.close();
        return;
      }
      // Clique no backdrop tem a propria dialog como alvo: o conteudo fica
      // todo dentro de .nt-sacola__caixa, entao clique interno nunca cai aqui.
      if (evento.target === sacola) sacola.close();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nt-frete"] && !Shopify.designMode) return;
  try {
    // <nt-frete> — cota o frete por CEP.
  //
  // Este bloco NAO passa pelo Liquid: chave dupla aqui dentro nao vira valor
  // nenhum, e escrever uma mesmo em comentario faz o Theme Check recusar o
  // arquivo inteiro. O que vem da loja chega por data-atributo no markup.
  (function () {
    'use strict';
    if (customElements.get('nt-frete')) return;

    // CEP -> UF por faixa. A tabela e feia e e o ponto: a Ajax API recusa o
    // pedido sem estado, e um servico de CEP resolveria o mesmo ao custo de um
    // terceiro que pode cair no meio da compra. As faixas sao dos Correios e
    // nao mudam; as descontinuidades (DF/GO, AM/RR, MT/RO) sao reais.
    var FAIXAS = [
      [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
      [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
      [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
      [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
      [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
      [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
      [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
      [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
      [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'],
      [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'],
      [90000, 99999, 'RS']
    ];

    function ufDoCep(cep) {
      var d = String(cep).replace(/\D/g, '');
      if (d.length !== 8) return null;
      var p = parseInt(d.slice(0, 5), 10);
      for (var i = 0; i < FAIXAS.length; i++) {
        if (p >= FAIXAS[i][0] && p <= FAIXAS[i][1]) return FAIXAS[i][2];
      }
      return null;
    }
    // Exposto para a bancada conferir a tabela sem guardar uma copia dela.
    window.ntUfDoCep = ufDoCep;

    function espera(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    // Erro com recado proprio: sacola vazia nao e falha, e uma condicao que
    // pede outra frase.
    function Vazia() {}
    Vazia.prototype = Object.create(Error.prototype);

    /* ---- A SACOLA, pela Ajax API ---------------------------------- */
    async function pelaSacola(cep, uf) {
      var sacola = await (await fetch('/cart.js')).json();
      if (!sacola.item_count) throw new Vazia();
      return cotarAjax(cep, uf);
    }

    // O pedido em si, sem olhar o que tem na sacola. Separado de pelaSacola
    // porque a pagina do produto tambem passa por aqui, com a sacola arrumada
    // por ela mesma logo antes.
    async function cotarAjax(cep, uf) {
      var busca = new URLSearchParams();
      busca.set('shipping_address[zip]', cep);
      busca.set('shipping_address[country]', 'Brazil');
      busca.set('shipping_address[province]', uf);

      await fetch('/cart/prepare_shipping_rates.json?' + busca, { method: 'POST' });

      // O `async` responde 202 enquanto a transportadora nao respondeu. O teto
      // de 20 s existe porque sem ele um carrier mudo deixa o botao
      // desabilitado para sempre.
      for (var i = 0; i < 27; i++) {
        await espera(750);
        var r = await fetch('/cart/async_shipping_rates.json?' + busca);
        if (r.status === 200) {
          return ((await r.json()).shipping_rates || []).map(function (t) {
            return {
              nome: t.presentment_name || t.name,
              preco: parseFloat(t.price),
              dias: t.delivery_days && t.delivery_days.length
                ? Math.max.apply(null, t.delivery_days) : null
            };
          });
        }
        if (r.status !== 202) throw new Error('HTTP ' + r.status);
      }
      throw new Error('demorou demais');
    }

    /* ---- UM PRODUTO, pela Storefront API --------------------------- */
    var CRIAR = 'mutation($l:[CartLineInput!]!,$a:[CartSelectableAddressInput!]!){' +
      'cartCreate(input:{lines:$l,buyerIdentity:{countryCode:BR},delivery:{addresses:$a}}){' +
      'cart{id} userErrors{message}}}';
    // O @defer e obrigatorio: a API recusa withCarrierRates sem ele.
    var COTAR = 'query($id:ID!){cart(id:$id){ ... @defer(label:"f"){' +
      'deliveryGroups(first:5,withCarrierRates:true){nodes{deliveryOptions{' +
      'title estimatedCost{amount}}}}}}}';

    async function doProduto(cfg, variante, quantidade, cep, uf) {
      function chamar(query, variables, accept) {
        return fetch('https://' + cfg.dominio + '/api/' + cfg.versao + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token,
            Accept: accept || 'application/json'
          },
          body: JSON.stringify({ query: query, variables: variables })
        });
      }

      var criada = await (await chamar(CRIAR, {
        l: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variante, quantity: quantidade }],
        // CEP, estado e pais, e mais nada: e o suficiente para a cotacao
        // sair completa, e foi conferido. Mandar rua e cidade inventadas
        // ("Rua", "Cidade") seria dar a transportadora um dado falso para uma
        // conta que ela faz pelo CEP de qualquer jeito.
        a: [{ selected: true, address: { deliveryAddress: {
          provinceCode: uf, countryCode: 'BR', zip: cep
        } } }]
      })).json();
      var carrinho = criada.data && criada.data.cartCreate && criada.data.cartCreate.cart;
      if (!carrinho) throw new Error('carrinho nao criado');

      // INSISTE ATE VIR ALGO. O @defer entrega o que ja esta pronto: com o
      // carrinho recem-criado a transportadora costuma nao ter respondido
      // ainda, e a resposta volta em menos de um segundo com o grupo VAZIO —
      // que e indistinguivel de "nao entregamos ai". Foi assim que a tela
      // disse "nao ha entrega para esse CEP" para a Avenida Paulista.
      //
      // Mesmo formato do laco da sacola: tenta, espera, tenta de novo. Dez
      // voltas com pausa de 800 ms; passou disso, e vazio de verdade.
      var opcoes = [];
      for (var volta = 0; volta < 10 && !opcoes.length; volta++) {
        if (volta) await espera(800);

        // Resposta multipart: cada parte e uma linha de JSON, e o corpo
        // inteiro chega junto — nao vale um leitor de stream para duas partes.
        var texto = await (await chamar(COTAR, { id: carrinho.id }, 'multipart/mixed')).text();
        texto.split('\n').forEach(function (linha) {
          linha = linha.trim();
          if (linha.charAt(0) !== '{') return;
          var j;
          try { j = JSON.parse(linha); } catch (e) { return; }
          var partes = j.incremental || [{ data: j.data && j.data.cart }];
          partes.forEach(function (p) {
            var g = p.data && p.data.deliveryGroups;
            if (g && g.nodes) g.nodes.forEach(function (n) {
              opcoes = opcoes.concat(n.deliveryOptions || []);
            });
          });
        });
      }

      // Preco sim, prazo nao: a Storefront NAO TEM CAMPO DE PRAZO. O
      // CartDeliveryOption tem code, title, description, handle,
      // deliveryMethodType e estimatedCost, e mais nada, e nesta loja
      // `description` volta vazia nas cinco opcoes. Quem completa e
      // prazosDaSacola, logo abaixo.
      return opcoes.map(function (o) {
        return { nome: o.title, preco: parseFloat(o.estimatedCost.amount), dias: null };
      });
    }

    /* ---- O PRAZO, que so a Ajax API tem --------------------------- */
    //
    // A Envia manda o prazo, e a Shopify so o repassa em `delivery_days` do
    // async_shipping_rates. Essa porta cota A SACOLA, e com a sacola vazia
    // responde 422 "este carrinho nao exige frete" — que e o estado de quem
    // esta montando o kit. Entao a sacola ganha uma linha por alguns segundos,
    // so para a pergunta poder ser feita, e a linha sai em seguida.
    //
    // A linha carrega a propriedade _nt_frete. Serve para tres coisas: nasce
    // como linha PROPRIA mesmo que o kit ja esteja na sacola (linha e chaveada
    // por variante MAIS propriedades), some do checkout por comecar com _, e
    // deixa marca para ser reconhecida e varrida depois.
    //
    // A sacola so e tocada quando esta VAZIA. Com item dentro a pergunta ja
    // pode ser feita como esta, e mexer seria risco a troco de nada.
    //
    // O prazo nao muda com o peso: e o tempo de transito entre dois CEPs para
    // aquele servico. Por isso vale mesmo quando a sacola cotada nao e
    // exatamente o kit escolhido. O PRECO, esse sim muda, e continua vindo da
    // Storefront, que cota o kit exato sem encostar em sacola nenhuma.
    async function tirarLinha(chave) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: chave, quantity: 0 })
      });
    }

    // Rede de seguranca para o caso de a pessoa sair da pagina no meio da
    // consulta: sem isto sobraria um kit fantasma na sacola dela.
    function varrerSobras(sacola) {
      var sobras = (sacola.items || []).filter(function (i) {
        return i.properties && i.properties._nt_frete;
      });
      return Promise.all(sobras.map(function (i) { return tirarLinha(i.key); }));
    }

    async function prazosDaSacola(variante, cep, uf) {
      var sacola = await (await fetch('/cart.js')).json();
      await varrerSobras(sacola);

      var chave = null;
      var restantes = sacola.item_count - (sacola.items || []).filter(function (i) {
        return i.properties && i.properties._nt_frete;
      }).length;

      if (!restantes) {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variante, quantity: 1, properties: { _nt_frete: '1' } }]
          })
        });
        // Variante esgotada nao entra, e ai simplesmente nao ha prazo: preco
        // sem prazo continua sendo melhor que prazo inventado.
        if (!r.ok) return {};
        var add = await r.json();
        chave = add.items && add.items[0] && add.items[0].key;
      }

      var sair = function () {
        if (!chave) return;
        var fd = new FormData();
        fd.append('id', chave);
        fd.append('quantity', '0');
        navigator.sendBeacon('/cart/change.js', fd);
      };
      window.addEventListener('beforeunload', sair);

      try {
        var mapa = {};
        (await cotarAjax(cep, uf)).forEach(function (t) {
          if (t.dias) mapa[t.nome] = t.dias;
        });
        return mapa;
      } finally {
        window.removeEventListener('beforeunload', sair);
        if (chave) await tirarLinha(chave);
      }
    }

    customElements.define(
      'nt-frete',
      class extends HTMLElement {
        connectedCallback() {
          this.campo = this.querySelector('[data-nt-frete-cep]');
          this.bt = this.querySelector('[data-nt-frete-bt]');
          this.estado = this.querySelector('[data-nt-frete-estado]');
          this.lista = this.querySelector('[data-nt-frete-lista]');
          if (!this.campo || !this.bt) return;

          this.moeda = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: this.getAttribute('data-moeda') || 'BRL'
          });

          this.noProduto = this.getAttribute('data-origem') === 'produto';
          if (this.noProduto) {
            this.cfg = {
              dominio: this.getAttribute('data-dominio'),
              token: this.getAttribute('data-token'),
              versao: this.getAttribute('data-versao') || '2025-07'
            };
            // O montador de kit guarda a escolha no <select name="id">.
            // Trocou de kit, o valor na tela passa a ser de outro produto.
            this.seletor = document.querySelector('[data-nt-id]');
            if (this.seletor) this.seletor.addEventListener('change', this.limpar.bind(this));
          }

          this.campo.addEventListener('input', this.mascara.bind(this));
          this.campo.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); this.calcular(); }
          }.bind(this));
          this.bt.addEventListener('click', this.calcular.bind(this));
        }

        mascara() {
          var d = this.campo.value.replace(/\D/g, '').slice(0, 8);
          this.campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        }

        limpar() {
          this.lista.hidden = true;
          this.aviso('');
        }

        aviso(texto, erro) {
          this.estado.textContent = texto;
          this.estado.classList.toggle('nt-frete__estado--erro', !!erro);
          this.estado.hidden = !texto;
        }

        async calcular() {
          var uf = ufDoCep(this.campo.value);
          if (!uf) {
            this.lista.hidden = true;
            this.aviso('CEP incompleto ou inexistente. Confira os 8 dígitos.', true);
            return;
          }
          var cep = this.campo.value;

          this.bt.disabled = true;
          this.lista.hidden = true;
          this.aviso('Consultando a transportadora…');

          try {
            var taxas;
            if (this.noProduto) {
              var variante = this.seletor && this.seletor.value;
              if (!variante) throw new Error('sem variante');
              // As duas consultas ao mesmo tempo: uma traz o preco do kit
              // exato, a outra o prazo. Em paralelo porque sao independentes,
              // e em serie a espera seria a soma das duas.
              //
              // O prazo e o unico que pode faltar sem estragar a resposta:
              // se ele falhar, a lista sai com preco e sem prazo, que e o que
              // ela fazia antes. Por isso o catch aqui e nao la fora.
              var par = await Promise.all([
                doProduto(this.cfg, variante, 1, cep, uf),
                prazosDaSacola(variante, cep, uf).catch(function () { return {}; })
              ]);
              taxas = par[0];
              taxas.forEach(function (t) { t.dias = par[1][t.nome] || null; });
            } else {
              taxas = await pelaSacola(cep, uf);
            }
            this.mostrar(taxas, uf);
          } catch (e) {
            this.aviso(
              e instanceof Vazia
                ? 'Coloque um kit na sacola para calcular o frete.'
                : 'Não deu para consultar o frete agora. Tente de novo em instantes.',
              true
            );
          } finally {
            this.bt.disabled = false;
          }
        }

        mostrar(taxas, uf) {
          if (!taxas.length) {
            this.aviso('Não há entrega para esse CEP (' + uf + ').', true);
            return;
          }
          this.aviso('Entrega para ' + this.campo.value + ' (' + uf + '):');

          // Da mais barata para a mais cara, e TODAS. O corte em tres existia
          // porque a lista ficava acima do botao de finalizar e o empurrava
          // para baixo; com ela embaixo nada mais se move, e esconder opcao so
          // tira escolha de quem quer comparar.
          taxas = taxas.slice().sort(function (a, b) { return a.preco - b.preco; });

          // Montado em nos e nao por innerHTML: o nome da transportadora vem
          // de um app de terceiro, e concatenar texto de fora num innerHTML e
          // como se escreve uma injecao sem querer.
          this.lista.textContent = '';
          taxas.forEach(function (t) {
            var li = document.createElement('li');
            li.className = 'nt-frete__item';

            var nome = document.createElement('span');
            nome.className = 'nt-frete__nome';
            nome.textContent = t.nome;
            if (t.dias) {
              var prazo = document.createElement('span');
              prazo.className = 'nt-frete__prazo';
              prazo.textContent = 'em até ' + t.dias + (t.dias === 1 ? ' dia útil' : ' dias úteis');
              nome.appendChild(prazo);
            }

            var preco = document.createElement('span');
            preco.className = 'nt-frete__preco';
            preco.textContent = this.moeda.format(t.preco);

            li.appendChild(nome);
            li.appendChild(preco);
            this.lista.appendChild(li);
          }, this);

          this.lista.hidden = false;
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nt-reserva"] && !Shopify.designMode) return;
  try {
    // <nt-reserva> — o modal de reserva e a confirmacao.
  //
  // Este bloco NAO passa pelo Liquid: chave dupla aqui dentro nao vira valor
  // nenhum, e escrever uma mesmo em comentario faz o Theme Check recusar o
  // arquivo inteiro. O que vem da loja chega por data-atributo no markup.
  (function () {
    'use strict';
    if (customElements.get('nt-reserva')) return;

    var ESPERA_MS = 60000;
    var CHAVE = 'nt-reserva-espera';
    var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

    function guardado() {
      try { return Number(localStorage.getItem(CHAVE) || 0); } catch (e) { return 0; }
    }
    function guardar(ate) {
      try { localStorage.setItem(CHAVE, String(ate)); } catch (e) { /* modo anonimo */ }
    }

    customElements.define(
      'nt-reserva',
      class extends HTMLElement {
        connectedCallback() {
          this.modal = this.querySelector('[data-nt-res-modal]');
          this.ok = this.querySelector('[data-nt-res-ok]');
          this.form = this.querySelector('[data-nt-res-form]');
          if (!this.modal || !this.form) return;

          this.url = this.getAttribute('data-url');
          this.nome = this.querySelector('[data-nt-res-nome]');
          this.email = this.querySelector('[data-nt-res-email]');
          this.whats = this.querySelector('[data-nt-res-whats]');
          this.isca = this.querySelector('[data-nt-res-isca]');
          this.enviar = this.querySelector('[data-nt-res-enviar]');
          this.aviso = this.querySelector('[data-nt-res-aviso]');
          this.alvoProduto = this.querySelector('[data-nt-res-produto]');
          this.okTitulo = this.querySelector('[data-nt-res-ok-titulo]');

          // Delegado no documento: os botoes de reservar nascem em secoes
          // diferentes, e alguns so aparecem quando o produto esgota. Escutar
          // aqui dispensa cada secao de saber que este modal existe.
          document.addEventListener('click', this.talvezAbrir.bind(this));

          // O CLIQUE QUE CHEGOU ANTES DAQUI. Este arquivo e um bundle com
          // `defer`: entre a pagina ficar clicavel e ele rodar existe uma
          // janela de centenas de milissegundos numa rede boa, e de segundos
          // num celular ruim. Nela o gatilho ainda e um link, e clicar levava
          // a pagina de venda de um produto esgotado — o oposto do que o botao
          // promete. O <script> de parse do snippet segura esse clique e
          // guarda o gatilho aqui.
          if (window.__ntReservaPendente) {
            var pendente = window.__ntReservaPendente;
            window.__ntReservaPendente = null;
            this.abrirPara(pendente);
          }

          this.querySelector('[data-nt-res-fechar]').addEventListener('click', function () {
            this.modal.close();
          }.bind(this));
          this.querySelector('[data-nt-res-ok-fechar]').addEventListener('click', function () {
            this.ok.close();
          }.bind(this));

          // Clique no fundo escurecido tem a propria <dialog> como alvo: o
          // conteudo todo mora em .nt-res__caixa, entao clique interno nunca
          // cai aqui.
          [this.modal, this.ok].forEach(function (d) {
            d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
          });

          this.whats.addEventListener('input', this.mascara.bind(this));
          this.form.addEventListener('submit', this.enviarForm.bind(this));
        }

        talvezAbrir(evento) {
          var g = evento.target.closest('[data-nt-reserva], a[href="#reserva"]');
          if (!g) return;
          evento.preventDefault();
          this.abrirPara(g);
        }

        abrirPara(g) {
          this.produto = {
            handle: g.getAttribute('data-nt-produto') || '',
            titulo: g.getAttribute('data-nt-titulo') || '',
            variante: g.getAttribute('data-nt-variante') || '',
            configuracao: null
          };
          // A CONFIGURACAO vem pronta do gatilho, em JSON. Quem monta e quem
          // sabe: o configurador de kit conhece o nome de cada opcao e o valor
          // marcado naquele instante. Aqui so se le — e se o JSON estiver
          // torto, segue sem ele, porque configuracao e detalhe do aviso e nao
          // condicao da reserva.
          var cfg = g.getAttribute('data-nt-config');
          if (cfg) {
            try { this.produto.configuracao = JSON.parse(cfg); } catch (e) { /* segue sem */ }
          }
          // Sem produto no gatilho, vale o da pagina — um "Reservar" solto
          // numa pagina de produto quer dizer aquele produto. Sem os dois, o
          // modal nao abre: reserva sem produto nao e reserva de nada.
          this.produto.handle = this.produto.handle || this.getAttribute('data-nt-produto') || '';
          this.produto.titulo = this.produto.titulo || this.getAttribute('data-nt-titulo') || '';
          if (!this.produto.handle || !this.produto.titulo) return;

          this.alvoProduto.textContent = this.produto.titulo;
          this.dizer('');
          this.modal.showModal();
        }

        // Formata enquanto digita, mas o que vale e o digito: o servidor
        // guarda so numero, senao "(11) 9..." e "11 9..." contariam como duas
        // pessoas e o limite por contato nao valeria nada.
        mascara() {
          var d = this.whats.value.replace(/\D/g, '').slice(0, 11);
          var saida = d;
          if (d.length > 2) saida = '(' + d.slice(0, 2) + ') ' + d.slice(2);
          if (d.length > 7) {
            var corte = d.length > 10 ? 7 : 6;
            saida = '(' + d.slice(0, 2) + ') ' + d.slice(2, corte) + '-' + d.slice(corte);
          }
          this.whats.value = saida;
        }

        campoErro(seletor, texto) {
          var el = this.querySelector(seletor);
          el.textContent = texto || '';
          el.hidden = !texto;
        }

        dizer(texto, erro) {
          this.aviso.textContent = texto;
          this.aviso.classList.toggle('nt-res__aviso--erro', !!erro);
          this.aviso.hidden = !texto;
        }

        async enviarForm(evento) {
          evento.preventDefault();

          var falta = Math.ceil((guardado() - Date.now()) / 1000);
          if (falta > 0) {
            this.dizer('Aguarde ' + falta + 's antes de enviar outra reserva.', true);
            return;
          }

          var email = this.email.value.trim();
          var whats = this.whats.value.replace(/\D/g, '');
          this.campoErro('[data-nt-res-erro-email]', EMAIL.test(email) ? '' : 'E-mail inválido');
          this.campoErro('[data-nt-res-erro-whats]', whats.length >= 10 && whats.length <= 15 ? '' : 'WhatsApp inválido');
          if (!EMAIL.test(email) || whats.length < 10 || whats.length > 15) return;

          this.enviar.disabled = true;
          this.dizer('Enviando…');

          try {
            // O QUE JA ESTA NA SACOLA entra na configuracao. Quem reserva um
            // produto costuma estar levando outro junto, e o que ela escolheu
            // ali — case personalizada, garantia estendida — e parte do pedido
            // que quem le no Discord precisa ver. Sem lista de handles
            // cravada: vale qualquer item, menos o proprio produto reservado,
            // que ja e o titulo da mensagem.
            var config = Object.assign({}, this.produto.configuracao || {});
            try {
              var sacola = await (await fetch('/cart.js')).json();
              (sacola.items || []).forEach(function (item) {
                if (item.handle === this.produto.handle) return;
                config['Na sacola: ' + item.product_title] =
                  item.quantity + (item.variant_title ? ' — ' + item.variant_title : '');
              }, this);
            } catch (e) { /* sacola indisponivel nao impede a reserva */ }

            var r = await fetch(this.url, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                nome: this.nome.value.trim(),
                email: email,
                whatsapp: whats,
                sobrenome: this.isca.value,
                produto_handle: this.produto.handle,
                produto_titulo: this.produto.titulo,
                variante: this.produto.variante,
                configuracao: Object.keys(config).length ? config : null
              })
            });
            var corpo = await r.json().catch(function () { return {}; });
            if (!r.ok) {
              // A funcao devolve frase pronta em portugues nos limites; para o
              // resto, uma generica — mensagem de erro de servidor descreve
              // tabela e coluna, e nao e assunto de quem esta comprando.
              this.dizer(r.status === 429 && corpo.erro
                ? corpo.erro
                : 'Não deu para registrar agora. Tente de novo em instantes.', true);
              return;
            }

            guardar(Date.now() + ESPERA_MS);
            this.form.reset();
            this.dizer('');
            this.campoErro('[data-nt-res-erro-email]', '');
            this.campoErro('[data-nt-res-erro-whats]', '');
            this.modal.close();
            this.okTitulo.textContent = 'Seu ' + this.produto.titulo + ' está reservado';
            this.ok.showModal();
          } catch (e) {
            this.dizer('Não deu para registrar agora. Tente de novo em instantes.', true);
          } finally {
            this.enviar.disabled = false;
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
